import { Component } from "@angular/core";

@Component({
  selector: "best-scenario-earnings-card",
  templateUrl: "./earnings-card.component.html",
})
export class EarningsCardComponent {}
